// extracted by mini-css-extract-plugin
export default {"placeholder":"prediction-widget_placeholder__AW3um","small_view":"prediction-widget_small_view__TFiIf","carousel_container":"prediction-widget_carousel_container__z9ysB"};